module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/invoices/download_report', 'Invoices.xlsx')
            }
          }
        }, [_vm._v("Export Selection")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/invoices/download_report_open', 'Invoices Open.xlsx')
            }
          }
        }, [_vm._v("Export Open Invoices")])], 2), _vm._v(" "), (_vm.hasSelections() && _vm.privUser) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-rocket"
        }), _vm._v(" Batch\n          ")]), _vm._v(" "), (_vm.privAdministrator && (_vm.isPlanned || _vm.isNumbered)) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalBulkEdit.show()
            }
          }
        }, [_vm._v("Bulk Edit")]) : _vm._e(), _vm._v(" "), (_vm.isPlanned) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalCreateInvoiceOk.show()
            }
          }
        }, [_vm._v("Create Invoice")]) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.overview.runBatch(_vm.sendEmail, 'document_reference')
            }
          }
        }, [_vm._v("Send Email")]) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.overview.runBatch(_vm.sendEmailReminder, 'document_reference')
            }
          }
        }, [_vm._v("Send Email Reminder")]) : _vm._e()], 2) : _vm._e()]
      }
    }, {
      key: "ExtraRowActions",
      fn: function(props) {
        return [(_vm.isNumbered) ? _c('button', {
          staticClass: "btn btn-default btn-sm",
          attrs: {
            "disabled": !_vm.privUser
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                name: 'invoicepayment',
                params: {
                  id: 'new'
                },
                query: {
                  invoice_id: props.rowData.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-money"
        })]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Contract/Student",
      "field": "contract_id",
      "optionListApiUrl": '/contracts/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), (_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Planned before",
      "type": "date",
      "field": "planned_before",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Expired after",
      "type": "date",
      "field": "expired_after",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNumbered) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Open",
      "field": "open",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Email Sent",
      "field": "email_sent",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), (!_vm.isCreditNote) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Document Type",
      "field": "document_type_id",
      "optionListApiUrl": '/document_types_invoices/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCreditNote) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Document Type",
      "field": "document_type_id",
      "optionListApiUrl": '/document_types_creditnotes/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNumbered) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Pro Forma",
      "field": "pro_forma",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Program",
      "field": "program_id",
      "optionListApiUrl": '/programs/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Intake",
      "field": "intake",
      "optionListApiUrl": '/contracts_intake/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Round",
      "field": "application_round",
      "optionListApiUrl": '/contracts_round/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), (_vm.isNumbered) ? _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Status",
      "field": "contract_status_id",
      "optionListApiUrl": '/contract_status/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }) : _vm._e(), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Instalments",
      "field": "instalments",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2), _vm._v(" "), _c('b-modal', {
    ref: "modalCreateInvoiceOk",
    attrs: {
      "title": "Create Invoices",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        _vm.$refs.overview.runBatch(_vm.createPDF, 'document_reference')
      }
    }
  }, [_vm._v("\n    Are you sure you want to create these invoices?\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "modalBulkEdit",
    attrs: {
      "title": "Bulk Edit",
      "ok-title": "Apply",
      "close-title": "Cancel"
    },
    on: {
      "ok": function($event) {
        _vm.bulkOk('/invoices/bulk_edit')
      }
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Amount",
      "field": "amount",
      "rec": _vm.bulkRec,
      "type": "money",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Planned Date",
      "field": "planned_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Expiration Date",
      "field": "expiration_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.isPlanned) ? _c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Extended Deadline",
      "field": "extended_deadline_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  }) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b6f9eca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Invoice/Overview.vue
// module id = 694
// module chunks = 1